'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './components/HeroSection';
import OneSystemSection from './components/OneSystemSection';
import AITransformationSection from './components/AITransformationSection';
import TransformationPathway from './components/TransformationPathway';
import IndustryPortals from './components/IndustryPortals';
import ProductEcosystem from './components/ProductEcosystem';
import D2CGrowthSection from './components/D2CGrowthSection';
import BusinessImpactSection from './components/BusinessImpactSection';
import EnterpriseCompliance from './components/EnterpriseCompliance';
import TrustSignals from './components/TrustSignals';
import SuccessStories from './components/SuccessStories';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ContactSalesModal from '@/components/ContactSalesModal';
import WhyUnifyMax from './components/WhyUnifyMax';

export default function Homepage4() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check if modal has been auto-opened before
    const hasAutoOpened = localStorage.getItem('contactSalesAutoOpened');
    
    if (!hasAutoOpened) {
      // Random delay between 15-20 seconds (15000-20000ms)
      const delay = Math.floor(Math.random() * 5000) + 15000;
      
      const timer = setTimeout(() => {
        setIsModalOpen(true);
        localStorage.setItem('contactSalesAutoOpened', 'true');
      }, delay);

      return () => clearTimeout(timer);
    }
  }, []);

  // Function to open modal (will be passed to child components)
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactSalesClick={openModal} />
      
      <main className="pt-16">
        <HeroSection />
        
        <OneSystemSection />
        
        <AITransformationSection />
        
        <WhyUnifyMax />
        
        <TransformationPathway />
        
        <ProductEcosystem />
        
        <D2CGrowthSection />
        
        <BusinessImpactSection />
        
        <EnterpriseCompliance />
        
        <IndustryPortals />
        <TrustSignals />
        
        <SuccessStories />
        
        <CTASection onContactSalesClick={openModal} />
      </main>

      <Footer />
      
      {/* Contact Sales Modal */}
      <ContactSalesModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}
